import { render, staticRenderFns } from "./transactionConfigComponent.vue?vue&type=template&id=33ce2a35&scoped=true&"
import script from "./transactionConfigComponent.vue?vue&type=script&lang=js&"
export * from "./transactionConfigComponent.vue?vue&type=script&lang=js&"
import style0 from "./transactionConfigComponent.vue?vue&type=style&index=0&id=33ce2a35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce2a35",
  null
  
)

export default component.exports